import { GAME_CONFIG } from './constants.js';

export class Food {
    constructor() {
        this.position = { x: 0, y: 0 };
        this.type = 'paint_can';
        this.score = GAME_CONFIG.FOOD_SCORE;
        this.animationTime = 0;
    }
    
    spawn(gridWidth, gridHeight, snakeSegments) {
        let newPosition;
        let attempts = 0;
        const maxAttempts = 100;
        
        do {
            newPosition = {
                x: Math.floor(Math.random() * gridWidth),
                y: Math.floor(Math.random() * gridHeight)
            };
            attempts++;
        } while (
            this.isPositionOccupied(newPosition, snakeSegments) && 
            attempts < maxAttempts
        );
        
        this.position = newPosition;
        this.animationTime = 0;
    }
    
    isPositionOccupied(position, snakeSegments) {
        return snakeSegments.some(segment => 
            segment.x === position.x && segment.y === position.y
        );
    }
    
    getPosition() {
        return { ...this.position };
    }
    
    getScore() {
        return this.score;
    }
    
    update(deltaTime) {
        this.animationTime += deltaTime;
    }
    
    render(ctx, gridSize) {
        const x = this.position.x * gridSize;
        const y = this.position.y * gridSize;
        
        // Animate the paint can
        const pulse = Math.sin(this.animationTime * 0.005) * 0.1 + 1;
        const size = gridSize * pulse;
        const offset = (gridSize - size) / 2;
        
        this.drawPaintCan(ctx, x + offset, y + offset, size);
    }
    
    drawPaintCan(ctx, x, y, size) {
        const centerX = x + size / 2;
        const centerY = y + size / 2;
        
        // Paint can body (white with red stripe)
        ctx.fillStyle = '#FFFFFF';
        ctx.fillRect(x + 2, y + 2, size - 4, size - 4);
        
        // Red stripe (Grassline branding)
        ctx.fillStyle = '#F44336';
        ctx.fillRect(x + 3, y + 3, size - 6, size / 6);
        
        // Paint can top
        ctx.fillStyle = '#E0E0E0';
        ctx.fillRect(x + 1, y + 1, size - 2, size / 4);
        
        // Paint can handle
        ctx.strokeStyle = '#9E9E9E';
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.arc(centerX, y + size / 6, size / 6, 0, Math.PI);
        ctx.stroke();
        
        // Paint spill effect
        ctx.fillStyle = '#4CAF50';
        ctx.beginPath();
        ctx.arc(centerX + size / 8, centerY + size / 4, size / 12, 0, Math.PI * 2);
        ctx.fill();
        
        // Highlight
        ctx.fillStyle = 'rgba(255, 255, 255, 0.5)';
        ctx.fillRect(x + 2, y + 2, size - 4, 2);
        
        // Shadow
        ctx.fillStyle = 'rgba(0, 0, 0, 0.2)';
        ctx.fillRect(x + 1, y + size - 1, size - 2, 1);
    }
}
